module.exports = __webpack_public_path__ + "img/HQ-PS24-V2-V20-T.be0b7d41.jpg";